import Slider from 'react-slick';   
import  './MarketPlacePageSlide.css';
const PrevArrow = (props) => (
  <button {...props} className="slick-prev">
    <img src="/img/rentshield/claims_arrow_left.svg" alt="Previous" width="48" height="48" />
  </button>
);

const NextArrow = (props) => (
  <button {...props} className="slick-next">
    <img src="/img/rentshield/claims_arrow_right.svg" alt="Next" width="48" height="48" />
  </button>
);


const MarketPlacePageSlide = ()=>{


// START slick
const settings = {
  slidesToShow: 5,
  slidesToScroll: 1,
  margin: 30,
  autoplay: true,
  autoplaySpeed: 2000,

  // autoplaySpeed: 0,  // No delay between scrolls
  // speed: 4000,  // Smooth continuous movement
  // cssEase: 'linear',

  loop: true,
  dots: false,
  arrows: false,
  focusOnSelect: true,
  centerPadding: '30px',
  prevArrow: <PrevArrow />,
  nextArrow: <NextArrow />,
  responsive: [
    {
      breakpoint: 1480,
      settings: {
        slidesToShow: 4, // Correcting the key to 'slidesToShow'
        infinite: true,
        centerPadding: "30px",
        margin: 30,
      },
    },
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 4, // Correcting the key to 'slidesToShow'
        infinite: true,
        centerPadding: "30px",
        margin: 30,
      },
    },
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 3, // Correcting the key to 'slidesToShow'
        infinite: true,
        margin: 30,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3, // Correcting the key to 'slidesToShow'
        margin: 20,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2, // Correcting the key to 'slidesToShow'
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2, // Correcting the key to 'slidesToShow'
      },
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 2, // Correcting the key to 'slidesToShow'
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1, // Correcting the key to 'slidesToShow'
        centerPadding: "30px",
      },
    },
  ],
};
// END slick

    return(
        <>
            {/* START marketPlacePageSlideMain */}
            <section className="marketPlacePageSlideMain">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <div className="marketPlacePageHead">
                                <h2>Helping Guest Come Back To Your Business</h2>
                            </div>
                        </div>
                    </div>
                </div> 

                <div className='row justify-content-center'>
                    <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                        <Slider {...settings}> 

                            <div className="item">
                                <div className="marketPlacePageDetail"> 
                                    <h3>Modernized<br/> Rental Experience</h3>
                                    <div className="marketPlacePageDetailEase">
                                        <figure>
                                            <img className="img-fluid" src="/img/Marketplace/refresh_icon.svg" alt="Rental Experience"/>
                                        </figure>
                                        <p>Guests skip the outdated rental counters and clunky apps. Hosts like 
                                        you deliver a smooth, tech-forward experience from search to pickup.</p>
                                    </div>
                                </div>
                            </div>
                          
                            <div className="item">
                                <div className="marketPlacePageDetail"> 
                                    <h3>Supporting<br/> Local Economy</h3>
                                    <div className="marketPlacePageDetailEase">
                                       <figure>
                                        <img className="img-fluid" src="/img/Marketplace/user_icon.svg" alt="Supporting Local Economy"/>
                                    </figure>
                                    <p>Every booking supports an independent host. No big chains or middlemen—just 
                                    real operators providing great service on their own terms.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="item">
                                <div className="marketPlacePageDetail"> 
                                    <h3>No Commissions. No<br/> Hidden Fees.</h3>
                                    <div className="marketPlacePageDetailEase">
                                        <figure>
                                        <img className="img-fluid" src="/img/Marketplace/not_touch_icon.svg" alt="Commissions"/>
                                    </figure>
                                    <p>What guests see is what they pay. Rates are upfront, policies are clear, 
                                    and every dollar goes straight to the host they choose.</p>
                                    </div>
                                </div>
                            </div>
                   
                            <div className="item">
                                <div className="marketPlacePageDetail"> 
                                    <h3>Verified Drivers.<br/> Trusted Rentals.</h3>
                                    <div className="marketPlacePageDetailEase">
                                        <figure>
                                        <img className="img-fluid" src="/img/Marketplace/id_icon.svg" alt="Verified Drivers"/>
                                    </figure>
                                    <p>RentID™ vetting and visible DriverIQ™ Scores help foster a safer community where 
                                    hosts and guests can trust who they’re working with.</p>
                                    </div>
                                </div> 
                            </div>

                            <div className="item">
                                <div className="marketPlacePageDetail"> 
                                    <h3>Flexible Protection,<br/> Peace of Mind</h3>
                                    <div className="marketPlacePageDetailEase">
                                    <figure>
                                        <img className="img-fluid" src="/img/Marketplace/security_icon.svg" alt="Flexible Protection"/>
                                    </figure>
                                    <p>Guests choose the protection plan that fits their trip, with optional roadside 
                                    assistance —because peace of mind shouldn’t cost extra.</p>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="item">
                                <div className="marketPlacePageDetail"> 
                                    <h3>Find Your Favorites,<br/> Book Again</h3>
                                    <div className="marketPlacePageDetailEase">
                                        <figure>
                                            <img className="img-fluid" src="/img/Marketplace/favourite_icon.svg" alt="Find Your Favorites Book Again"/>
                                        </figure>
                                        <p>Enjoyed your last car rental host experience? Guests can follow profiles, save vehicles, 
                                        and rebook their go-to rides with just a few taps.</p>
                                    </div>
                                </div>
                            </div>
                                                        
                            <div className="item">
                                <div className="marketPlacePageDetail"> 
                                    <h3>Rate and Reward<br/> Excellent Hosts</h3>
                                    <div className="marketPlacePageDetailEase">
                                        <figure>
                                            <img className="img-fluid" src="/img/Marketplace/star_icon.svg" alt="Rate and Reward Excellent Hosts"/>
                                        </figure>
                                        <p>Reviews, tips, and positive feedback help guests recognize standout 
                                        hosts and shape a community built on excellent service.</p>
                                    </div>
                                </div>   
                            </div>
                                                        
                            <div className="item">
                                <div className="marketPlacePageDetail"> 
                                    <h3>One Profile. Limitless <br/> Possibilities.</h3>
                                    <div className="marketPlacePageDetailEase">
                                        <figure>
                                            <img className="img-fluid" src="/img/Marketplace/rocket-_icon.svg" alt="One Profile. Limitless Possibilities"/>
                                        </figure>
                                        <p>Guests manage all their trips across cities, vehicles, and hosts in 
                                        one clean, modern account—rental freedom made easy.</p>
                                    </div>
                                </div>
                            </div>

                        </Slider> 
      
                    </div>
                </div>  
            </section>
            {/* END marketPlacePageSlideMain */}
        </>
    )
}

export default MarketPlacePageSlide;